module.exports = __webpack_public_path__ + "static/media/Reliability.6d6af867.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Wealth/img/Reliability.png
// module id = 703
// module chunks = 0